import { forwardRef } from 'react';

import { baseClasses, containerClasses, sizeClasses } from 'components/cart/NewCartItem/ProductCardPrice.classes';
import type { ProductCardPriceProps } from 'components/cart/NewCartItem/ProductCardPrice.types';
import { getTestId } from 'utils/testing';
import { cn } from 'helpers/classnames';
import { removeTrailingZeroes } from 'helpers/ProductUtils';
import { CURRENT_PRICE_LABEL, ORIGINAL_PRICE_LABEL } from 'constants/price';

export const ProductCardPrice = forwardRef<HTMLElement, ProductCardPriceProps>((props: ProductCardPriceProps, ref) => {
  const { className, price, msrp, size = 'small', children, testId, ...forwardProps } = props;
  const isOnSale = parseFloat(String(price)) < parseFloat(String(msrp));
  const isOnSaleClasses = isOnSale ? 'zappos:text-red-350 text-[#ae4343]' : ''; // 6pm support

  return (
    <dd className={cn(containerClasses, className)} data-test-id={getTestId(testId)} ref={ref} {...forwardProps}>
      <ins className={cn(baseClasses, isOnSaleClasses, sizeClasses[size], 'no-underline')} data-test-id={getTestId(testId, 'price')}>
        {isOnSale && <span className="sr-only">{CURRENT_PRICE_LABEL}</span>}
        {`$${removeTrailingZeroes(Number(price).toFixed(2))}`}
      </ins>
      {isOnSale && (
        <del className="body-xs text-gray-600 line-through" data-test-id={getTestId(testId, 'msrp')}>
          <span className="sr-only">{ORIGINAL_PRICE_LABEL}</span>
          {`$${removeTrailingZeroes(Number(msrp).toFixed(2))}`}
        </del>
      )}
      {children}
    </dd>
  );
});

ProductCardPrice.displayName = 'ProductCardPrice';
